module.exports = __webpack_public_path__ + "img/GranBlocco_Perugina.71b5ac72.jpg";